import { useEffect, useRef } from "react"
import { io, Socket } from "socket.io-client"
import { logDebug, logHubError } from "../../utility/common/logError"
import { telephonyDomEvent, TelephonySocketMessage } from "../../models/Telephony/telephony"

const handleJsAgentMessage = (message: TelephonySocketMessage) => {
    const messageData = message.data
    logDebug("Got message from jsAgentSoket: ", message)
    if (messageData) {
        const event = new CustomEvent(telephonyDomEvent, { detail: messageData })
        document.dispatchEvent(event)
    }
}

const logName = "[JS-Agent-bridge]"

export const useJsAgentSocket = (telephony: string[]) => {
    const socketRef = useRef<Socket>()

    useEffect(() => {
        if (telephony.length > 0) {
            socketRef.current = io("/js-agent-operator-handler", {
                path: "/api/js-agent-service/wss",
                transports: ["websocket"],
                withCredentials: true
            })

            const socket = socketRef.current

            socket.on("connect", () => {
                logDebug(`${logName} Socket.IO connected`, socket.id)
            })

            socket.on("disconnect", () => {
                logDebug(`${logName} Socket.IO disconnected`)
            })

            socket.on("message", handleJsAgentMessage)

            socket.on("connect_error", err => {
                logHubError(logName, "connect_error", err.message)
            })
        }

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect()
            }
        }
    }, [telephony])
}
